import apiClient from '@/vue/apiClient.js'

export default {
  async getFirstClassification() {
    const url = '/settings/application/visitorclassifications/first'
    const response = await apiClient.get(url)
    return response.data
  },
  async getClassification(code) {
    const url = `/settings/application/visitorclassifications/${code}`
    const response = await apiClient.get(url)
    return response.data
  },
  async getSegment(classificationCode, code) {
    const url = `/settings/application/visitorclassifications/${classificationCode}/segment/${code}`
    const response = await apiClient.get(url)
    return response.data
  },
  async createSegment(classificationCode, segmentModel) {
    const url = `/settings/application/visitorclassifications/${classificationCode}/segment`
    const response = await apiClient.post(url, segmentModel)
    return response.data
  },
  async updateSegment(classificationCode, segmentModel) {
    const url = `/settings/application/visitorclassifications/${classificationCode}/segment/${segmentModel.code}`
    const response = await apiClient.put(url, segmentModel)
    return response.data
  },
}
